module.exports = __webpack_public_path__ + "static/img/nationTwo.cb92ab54.png";